import { SelectProps } from 'antd'

import { useDefaultSortingItem } from 'src/hooks'
import { useLocales } from 'src/locales'

export const useTransferConfig = () => {
  const { t } = useLocales()

  const { defaultSortingOption } = useDefaultSortingItem()

  const options: SelectProps['options'] = [
    defaultSortingOption,
    {
      value: 'createdAt',
      label: t('transfer.created_at_asc')
    },
    {
      value: '-createdAt',
      label: t('transfer.created_at_desc')
    },
    {
      value: 'status',
      label: t('tests_results.status_asc')
    },
    {
      value: '-status',
      label: t('tests_results.status_desc')
    },
    {
      value: 'personSimeCode',
      label: t('transfer.sime_code_asc')
    },
    {
      value: '-personSimeCode',
      label: t('transfer.sime_code_desc')
    },
    {
      value: 'personTarvCode',
      label: t('transfer.tarv_code_asc')
    },
    {
      value: '-personTarvCode',
      label: t('transfer.tarv_code_desc')
    },
    {
      value: 'personBirthDate',
      label: t('users.birth_date_asc')
    },
    {
      value: '-personBirthDate',
      label: t('users.birth_date_desc')
    },
    {
      value: 'personGender',
      label: t('transfer.gender_asc')
    },
    {
      value: '-personGender',
      label: t('transfer.gender_desc')
    }
  ]

  return { options }
}
